import React from 'react';
import PropTypes from 'prop-types';

const stringOrNode = PropTypes.oneOfType([PropTypes.string, PropTypes.node]);

export default class PaymentForm extends React.Component {
  static displayName = 'TourPage-BookingDetails-PaymentMethods-PaymentForm';
  static propTypes = {
    title: stringOrNode.isRequired,
    amount: stringOrNode.isRequired,
    hint: PropTypes.string.isRequired,
    action: PropTypes.object.isRequired,
    className: PropTypes.string,
  };
  static defaultProps = {
    className: '',
  };

  render() {
    const className = `section ${this.props.className}`;

    return (
      <div className={className}>
        <div className="title">{this.props.title}</div>
        <div className="TourPage-BookingDetails-PaymentMethods-Price">
          <div className="amount">{this.props.amount}</div>
          <div className="label">Total Price</div>
        </div>
        <div className="TourPage-BookingDetails-PaymentMethods-Hint">
          {this.props.hint}
        </div>
        <div className="TourPage-BookingDetails-PaymentMethods-Actions">
          <a
            href="#"
            className={this.props.action.className}
            onClick={this.props.action.onClick}
          >
            {this.props.action.text}
          </a>
        </div>
      </div>
    );
  }
}
